import React from "react";
import "./pageEmptySpace.css"

const PageEmptySpace =(props)=>{
    const{
    classEmpty = 'AppPageEmptySpace',
    data = { slogan: "Elakay works for", text: ["Art Lovers", "Trend Seekers", "Smart Shoppers", "YOU!"]}
    }= props
    return  <div className={classEmpty}>
   <p>{data.slogan} </p>
      <div className="droppingEmpty-texts">
    {data.text.map((text, index) => (
        <div key={index}>
          {text}
        </div> 
    ))}
       
      </div>
</div>

}
export default PageEmptySpace; 